import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React from 'react';
import Chart from 'react-apexcharts';

const GraficoLine = ({ categorias = [], conteudo = [], height }) => {
  return (
    <Chart
      options={{
        chart: {
          toolbar: {
            show: false,
          },
        },
        colors: ['#22D3EE'],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: false,
          theme: 'dark',
        },
        xaxis: {
          show: false,
          categories: categorias,
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: true,
          labels: {
            formatter(value) {
              return getCurrencySemSinalMonetario(value);
            },
          },
        },
      }}
      series={conteudo}
      type="line"
      height={height}
    />
  );
};

export default GraficoLine;
